module.exports = {
    "name": "",
    "description": "",
    "largeImageUrl": "",
    "mediumImageUrl": "",
    "pinImageUrl": "",
    "websiteUrl": "",
    "lat": null,
    "lng": null,
    "keywords": [
    ],
    "access": null,
    "type": null,
    "active": true,
    "dynamicLink1": { id: null, name: "", url: "", imageUrl: "" },
    "dynamicLink2": { id: null, name: "", url: "", imageUrl: "" }
};
